<!--
  Reusable Success Snackbar Component
  
  Usage Example:
  
  In your Vue component:
  ```vue
  <template>
    <div>
      <button @click="showSuccess">Show Success</button>
      <success-snackbar v-model="showSuccessMessage" :message="successMessage" />
    </div>
  </template>
  
  <script>
  import SuccessSnackbar from "../Base/SuccessSnackbar.vue";
  
  export default {
    components: { SuccessSnackbar },
    data() {
      return {
        showSuccessMessage: false,
        successMessage: "",
      };
    },
    methods: {
      showSuccess() {
        this.successMessage = "Operation completed successfully!";
        this.showSuccessMessage = true;
      },
    },
  };
  </script>
  ```
  
  Props:
  - value (Boolean): Controls visibility (use with v-model)
  - message (String): Message to display (default: "Success!")
  - timeout (Number): Auto-hide timeout in ms (default: 5000)
-->
<template>
  <v-snackbar v-model="isVisible" :timeout="timeout" color="success" top>
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="close">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SuccessSnackbar",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Success!",
    },
    timeout: {
      type: Number,
      default: 5000,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>
